import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OrderService } from '../../../service/order.service';
import { OrderDetailsModalComponent } from '../order-details-modal.component';

@Component({
  selector: 'app-order-details-mobile',
  templateUrl: './order-details-mobile.component.html',
  styleUrls: ['./order-details-mobile.component.scss']
})
export class OrderDetailsMobileComponent extends OrderDetailsModalComponent {

  constructor(
    activeModal: NgbActiveModal,
    orderService: OrderService,
    modalService: NgbModal,
    router: Router
  ) {
    super(activeModal,
      orderService,
      modalService,
      router,)
   }

}
